import type { TRuleWithTheme } from '@/styles/theme';

export const spacer: TRuleWithTheme<{
    space: number;
}> = ({ space }) => ({
    marginBottom: `${space}rem`,

    border: '1px solid transparent',
});
